import axios from 'axios'

const urlParams = new URLSearchParams(window.location.search);
const token = urlParams.get("token");

const dataFetcher = axios.create({
    baseURL: 'https://wmsapi.clgsv.com/api',
    headers: {
        ['Authorization']: `Bearer ${token}`
    }
})



export default dataFetcher